import produce from 'immer';
import { SEARCH_LOCAL_STORAGE_ID } from '@common/GlobalSearch/constants';
import { loadState } from '@helpers/localStorage';
import {
    TOGGLE_SEARCH_SIDEBAR_VISIBILITY,
    ADD_SEARCH_TERM,
    ADD_RECENT_SEARCH,
    ADD_SEARCH_RESULTS,
    OVERRIDE_RECENT_SEARCHES,
    DELETE_ALL_RECENT_SEARCHES,
} from '../actions/constants';
import type { GlobalSearchActions, State } from '../types';

const initialState: State = {
    sidebarVisibility: false,
    recentSearches: loadState(SEARCH_LOCAL_STORAGE_ID.newRecentSearches) ?? [],
    searchTerm: '',
    searchResults: null,
};

const globalSearch = produce((
    // eslint-disable-next-line @typescript-eslint/default-param-last
    draft,
    action: GlobalSearchActions,
) => {
    switch (action.type) {
        case TOGGLE_SEARCH_SIDEBAR_VISIBILITY:
            draft.sidebarVisibility = action.payload;
            break;

        case ADD_SEARCH_TERM: {
            draft.searchTerm = action.payload;
            break;
        }

        case ADD_RECENT_SEARCH: {
            const recentSearch = action.payload;
            const filterRecentSearch = draft.recentSearches
                .filter(({ token }) => token !== action.payload.token);

            draft.recentSearches = [recentSearch, ...filterRecentSearch];
            break;
        }

        case ADD_SEARCH_RESULTS: {
            draft.searchResults = action.payload;
            break;
        }

        case OVERRIDE_RECENT_SEARCHES: {
            draft.recentSearches = action.payload;
            break;
        }

        case DELETE_ALL_RECENT_SEARCHES:
            draft.recentSearches = [];
            break;

        default:
            break;
    }
}, initialState);

export default globalSearch;
